// Textes des notifications avec montant, partagés par le serveur (envoi) et le client (affichage).
type MoneyNotificationBody = (amount: string, data: Record<string, unknown>) => string;

export const MONEY_NOTIFICATION_BODIES: Readonly<Partial<Record<string, MoneyNotificationBody>>> = {
  PAYMENT_SUCCESS: (amount) =>
    `Votre paiement de ${amount} a été confirmé. Votre pack est activé !`,
  PAYMENT_FAILED: (amount) =>
    `Le paiement de ${amount} n'a pas abouti. Vous pouvez réessayer à tout moment.`,
  WALLET_CREDIT: (amount) => `${amount} ont été ajoutés à votre portefeuille.`,
  WALLET_DEBIT: (amount) => `${amount} ont été débités de votre portefeuille.`,
  WITHDRAWAL_SUBMITTED: (amount) =>
    `Votre demande de retrait de ${amount} est en cours de traitement.`,
  WITHDRAWAL_APPROVED: (amount) =>
    `Votre retrait de ${amount} a été approuvé et sera crédité sur votre moyen de paiement.`,
  WITHDRAWAL_REFUSED: (amount) =>
    `Votre demande de retrait de ${amount} a été refusée. Contactez le support pour plus d'informations.`,
  REFERRAL_REWARD_MONEY: (amount) =>
    `${amount} ont été ajoutés à votre portefeuille grâce à votre filleul.`,
  AMBASSADOR_COMMISSION_EARNED: (amount) =>
    `${amount} de commission grâce à l'utilisation de votre code promo.`,
  ADMIN_WITHDRAWAL_REQUEST: (amount, data) =>
    `${(data["userName"] as string | undefined) ?? "Un utilisateur"} demande un retrait de ${amount}.`,
  ADMIN_PAYMENT_ALERT: (amount, data) =>
    `Paiement de ${amount} confirmé${data["userName"] ? ` par ${String(data["userName"])}` : ""}.`,
};

// Notifications des admins : montants dans la devise comptable.
export const isAccountingNotification = (type: string): boolean => type.startsWith("ADMIN_");

export const buildMoneyNotificationBody = (
  type: string,
  data: Record<string, unknown> | null | undefined,
  formatFcfa: (amountFcfa: number) => string,
): string | undefined => {
  const body = MONEY_NOTIFICATION_BODIES[type];
  const amount = Number(data?.["amount"]);

  return body && Number.isFinite(amount) ? body(formatFcfa(amount), data ?? {}) : undefined;
};
